import { useEffect, useState } from 'react'
import { DebtAttributes } from '~/shared/api/debt'
import { DebtSourceTypesEnum } from '~/shared/config/enums'
import { formatDate } from '~/shared/lib/date'
import { GraceNotice } from '../styled'

type Props = { debt: DebtAttributes }

export const CommissionGraceNotice = ({ debt }: Props) => {
  const [now, setNow] = useState(Date.now)
  const dueAt = debt.commissionDueAt ? Date.parse(debt.commissionDueAt) : NaN

  useEffect(() => {
    const updateTime = () => setNow(Date.now())
    updateTime()
    // Короткий интервал безопасен и для сроков больше максимального setTimeout.
    const timer = window.setInterval(updateTime, 1000)
    window.addEventListener('focus', updateTime)
    document.addEventListener('visibilitychange', updateTime)
    return () => {
      window.clearInterval(timer)
      window.removeEventListener('focus', updateTime)
      document.removeEventListener('visibilitychange', updateTime)
    }
  }, [dueAt])

  if (
    debt.sourceType !== DebtSourceTypesEnum.EXTERNAL_PENALTY ||
    debt.commissionStatus !== 'PENDING' ||
    !(debt.deferredCommission && debt.deferredCommission > 0) ||
    !(debt.balance > 0) ||
    !(dueAt > now)
  )
    return null

  const money = (amount: number) =>
    amount.toLocaleString('ru-RU', { maximumFractionDigits: 2 })

  return (
    <GraceNotice role='status'>
      Погасите задолженность {money(debt.balance)} ₽ до{' '}
      {formatDate(new Date(dueAt), 'dd.MM.yyyy, HH:mm')} — иначе будет начислена
      комиссия {money(debt.deferredCommission)} ₽.
    </GraceNotice>
  )
}
